export const images = {
    brandLogo: '/images/jkmlogo.jpg',
  };